import { RouterView } from 'vue-router';
export default function RequisitionRoutes(staticTitle) {
    return [
        {
            path: '/pscmservice/requisition',
            name: 'pscmrequisition',
            meta: {
                title: `${staticTitle} - PSCM Service`
            },
            component: RouterView,
            children: [
                {
                    path: '/pscmservice/requisition',
                    name: 'requisition',
                    meta: {
                        title: `${staticTitle} - Requisition`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: 'info',
                    name: 'info',
                    meta: {
                        title: `${staticTitle} - Info`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: 'purchase-inquiry',
                    name: 'purchaseinquiry',
                    meta: {
                        title: `${staticTitle} - Purchase Inquiry`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: 'jci',
                    name: 'jci',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/jci/detail/:tag',
                    name: 'jcidetail',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/jci/Detail.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/jci/create',
                    name: 'jcicreate',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/jci/FormJci.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/jci/draft/:tag',
                    name: 'jcidraft',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/jci/FormJci.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/jci/revise/:tag',
                    name: 'jcirevise',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/jci/FormJci.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/jci/approval/:tag',
                    name: 'jciapproval',
                    meta: {
                        title: `${staticTitle} - Justifikasi Community Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/jci/FormApproval.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/fpk',
                    name: 'fpk',
                    meta: {
                        title: `${staticTitle} - Form Pembobotan Kontrak`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/fpk/detail/:tag',
                    name: 'fpkdetail',
                    meta: {
                        title: `${staticTitle} - Form Pembobotan Kontrak`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/fpk/Detail.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/fpk/create',
                    name: 'fpkcreate',
                    meta: {
                        title: `${staticTitle} - Form Pembobotan Kontrak`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/fpk/FormFpk.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/fpk/draft/:tag',
                    name: 'fpkdraft',
                    meta: {
                        title: `${staticTitle} - Form Pembobotan Kontrak`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/fpk/FormFpk.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf',
                    name: 'crf',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/index.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/draft/:tag',
                    name: 'crfdraft',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/FormDraft.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/create',
                    name: 'crfcreate',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/FormCrf.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/create/jci/:tag',
                    name: 'crfcreatejci',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/FormCrf.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/create/fpk/:tag',
                    name: 'crfcreatefpk',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/FormCrf.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/detail/:tag',
                    name: 'crfdetail',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/DetailCrf.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/revise/:tag',
                    name: 'crfrevise',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/FormRevise.vue');
                    }
                },
                {
                    path: '/pscmservice/requisition/crf/approval/:tag',
                    name: 'crfapproval',
                    meta: {
                        title: `${staticTitle} - Commercial Request Form`
                    },
                    component: () => {
                        return import('@/views/pscm/requisition/crf/ApprovalCrf.vue');
                    }
                },
                {
                    // path: "/pscmservice/contractreporting",
                    path: '/dashboard',
                    name: 'contractreporting',
                    meta: {
                        title: `${staticTitle} - Contract Reporting`
                    },
                    component: () => {
                        return import('@/views/crafted/general/Dashboard.vue'); // temporary
                    }
                }
            ]
        }
    ];
}
